import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { InputBoolean } from 'ng-zorro-antd/core/util';
import {ValidatorInfo} from '@core/models/validator.model';

@Component({
  selector: 'extend-form-item',
  templateUrl: './extend-form-item.component.html',
  styles: [`:host {width: 100%}`]
})
export class ExtendFormItemComponent implements OnChanges {
  @Input() labelText: string;
  @Input() @InputBoolean() noLabelText = false;
  @Input() errors: any;
  @Input() errorDefs: ValidatorInfo[];
  @Input() @InputBoolean() showError: boolean = false;

  @Input() @InputBoolean() isRequired = false;

  errorMessage:string = '';

  type = 'error';

  constructor() {
  }

  ngOnChanges(changes:any):void {
    var errors:any = this.errors;
    this.type = null;
    this.errorMessage = null;
    if (errors && this.showError) {
      this.setErrorMessage(errors)
    }
  }

  setErrorMessage(errors: any) {
    for(let error of this.errorDefs) {
      let key = error.errorName
      if (errors[key]) {
        this.errorMessage = error.errorDescription;
        this.type = error.type ?? 'error';
        return true;
      }
    }
    return false;
  }

}
